import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { FileDnsServiceComponent } from './file-dns-service.component';
import { FileDnsServiceService } from './file-dns-service.service';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';
import { CanLeaveGuard } from 'app/common/guards';

const routes: Routes = [
    {
        path: '',
        component: FileDnsServiceComponent,
        canDeactivate: [CanLeaveGuard],
    },
];

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
    ],
    providers: [
        FileDnsServiceService,
    ],
    exports: [FileDnsServiceComponent],
    declarations: [FileDnsServiceComponent],
})

export class FileDnsServiceModuleEmbed { }

@NgModule({
    imports: [
        FileDnsServiceModuleEmbed,
        RouterModule.forChild(routes),
    ],
})

export class FileDnsServiceModule { }
